export function isUnifiedEntryEnabled() {
  return String(process.env.VUE_APP_BOOKING_UNIFIED_ENTRY || '').toLowerCase() === 'true'
}
